/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import styled from 'styled-components';
import { nFormatter } from '@/utils/experience-utils';

type Prop = { positive: boolean; neutral: boolean; negative: boolean };
const Container = styled.div`
  position: absolute;
  left: 120%;
  top: -4px;
  background-color: ${(p: Prop) =>
    p.positive ? `#1ed58b` : p.neutral ? `#edc400` : `#ff7f00`};
  color: white;
  font-family: 'Inter', serif;
  font-weight: 600;
  padding: 0.5rem;
  border-radius: 8px;
  font-size: 11px;

  text-align: center;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.09), 0 1px 4px 0 rgba(7, 6, 6, 0.04);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TriangleLeft = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  top: -1.5px;
  left: 110%;

  border-right: 10px solid
    ${(p: Prop) =>
      p.positive
        ? `rgba(30, 213, 139, 0.89)`
        : p.neutral
        ? `rgba(237, 196, 0, 0.91)`
        : `rgba(255, 127, 0, 0.91)`};
`;

type Props = { show?: boolean; value?: number };
export const Uplift: FC<Props> = ({ show, value }) => {
  if (!show || value === 0) {
    return null;
  }
  const isPositive = value >= 3;
  const isNeutral = value < 3 && value >= -3;
  const isNegative = value < -3;

  return (
    <>
      <TriangleLeft
        positive={isPositive}
        neutral={isNeutral}
        negative={isNegative}
      />
      <Container
        positive={isPositive}
        neutral={isNeutral}
        negative={isNegative}
      >
        {value >= 0 ? `+` : `-`}
        {nFormatter(Math.abs(value), Math.abs(value) > 100 ? 0 : 1)}%
      </Container>
    </>
  );
};
